<template>
    <div>
        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="!isLoading && campaign === null"
        >
            <div class="alert-body">
                Paylaşım Bulunamadı
                <b-link
                    class="alert-link"
                    :to="{ name: 'campaign' }"
                >
                    Paylaşım Raporları
                </b-link>
                sayfasını görüntüle
            </div>
        </b-alert>

        <loading-card v-if="isLoading"></loading-card>
        <div v-else-if="campaign !== null">
            <b-card
                no-body
                class="invoice-preview-card invoice-preview border-danger"
            >
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">
                    <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <!-- Header: Left Content -->
                        <div>
                            <div class="logo-wrapper">
                                <h3 class="text-primary">
                                    {{ campaign.campaign_name || 'Paylaşım Adı Bulunamadı' }}
                                </h3>
                            </div>
                            <b-col
                                cols="12"
                                class="p-0"
                                v-if="!group_id"
                            >
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="pr-1">Link:</td>
                                                <span v-if="campaign.link">
                                                    <a :href="campaign.link" target="_blank" rel="noopener noreferrer">{{ campaign.link }}</a>
                                                </span>
                                                <span v-else>
                                                    Link Yok
                                                </span>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Paylaşım Türü:</td>
                                                <td>{{ campaign.page_type || 'Belirtilmemiş' }}</td>
                                            </tr>
                                            <tr class="text-success">
                                                <td class="pr-1">Link İçi Oran:</td>
                                                <td class="font-weight-bold">
                                                    %{{ campaign.link_ici_odeme_orani || 0 }}
                                                </td>
                                            </tr>
                                            <tr class="text-danger">
                                                <td class="pr-1">Link Dışı Oran:</td>
                                                <td class="font-weight-bold">
                                                    %{{ campaign.link_disi_odeme_orani || 0 }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                            <b-col
                                cols="12"
                                class="p-0"
                                v-else
                            >
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="pr-1">Açıklama:</td>
                                                <span v-if="campaign.description">
                                                    {{ campaign.description }}
                                                </span>
                                                <span v-else>
                                                    Açıklama Yok
                                                </span>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Kayıt Tarihi:</td>
                                                <td>{{ formatDate(campaign.created_date) || 'Belirtilmemiş' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                        </div>

                        <!-- Header: Right Content -->
                        <div class="mt-md-0 mt-2">
                            <h4 class="invoice-title" v-if="!group_id">
                            </h4>
                            <div class="invoice-date-wrapper justify-content-end" v-if="!group_id">
                                <p class="invoice-date-title">Başlangıç Tarihi:</p>
                                <p class="invoice-date" v-if="campaign.start_date">
                                    {{ formatDate(campaign.start_date) }}
                                </p>
                                <p class="invoice-date semibold text-danger" v-else>
                                    Tanımlanmamış
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end" v-if="!group_id">
                                <p class="invoice-date-title">Bitiş Tarihi:</p>
                                <p class="invoice-date" v-if="campaign.end_date">
                                    {{ formatDate(campaign.end_date) }}
                                </p>
                                <p class="invoice-date semibold text-danger" v-else>
                                    Tanımlanmamış
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Durum:</p>
                                <p class="invoice-date semibold">
                                    <b-badge v-if="campaign.status" variant="success">Aktif</b-badge>
                                    <b-badge v-else variant="danger">Pasif</b-badge>
                                </p>
                            </div>
                        </div>
                    </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Invoice Client & Payment Details -->
                <b-card-body
                    class="invoice-padding pt-0"
                >
                    <b-row class="invoice-spacing">
                        <b-col
                            xl="12"
                            md="12"
                        >
                            <global-summary :groupId="group_id" />
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
            <b-tabs
                pills
                >

                
                <b-tab>
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline"> {{ campaign.platform_id == 1 ? 'Bağlı Fenomenler' : 'Paylaşımlar'}} </span>
                    </template>
                    <campaign-list :tableColumns="tableColumns" :params="params" :headerShow="false"></campaign-list>
                </b-tab>

            </b-tabs>

        </div>
    </div>
</template>


<script>
    import { BRow,BLink, BAlert,BBadge,BCardTitle, BCol, BCard, BCardHeader, BCardBody, BTab, BTabs } from 'bootstrap-vue';
    import LoadingCard from '@/layouts/components/isLoading.vue';
    import GlobalSummary from '@/components/GlobalSummary.vue';
    import CampaignList from './Links.vue';
    export default {
        components: {
            BTab, 
            BTabs,
            BRow,
            BCol,
            BLink,
            BCard,
            BCardHeader,
            BCardBody,
            BAlert,
            BBadge,
            BCardTitle,

            LoadingCard,
            GlobalSummary,
            CampaignList
        },
        data() {
            return {
                campaign: null,
                isLoading : true,
                influencer: {},
                isActiveTab: {},
                group_id: Number(this.$route.params.id),
                tableColumns : [
                    { key: 'id', sortable: true },
                    { key: 'campaign_name', label: 'Paylaşım', sortable: true },
                    { key: 'event_count',label:'Ziyaret', sortable: false },
                    { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
                    { key: 'order_count',label:'Sipariş Adedi', sortable: false },
                    { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
                    { key: 'status', label: 'Durum'},
                    { key: 'actions', label: 'Detay'},
                ],
                params:{
                    filter:{
                        group_id:Number(this.$route.params.id),
                    }
                },
            }
        },
        methods: {
            getCampaign () {
                this.$http.get('/link/category', {
                    params: {
                        id:this.group_id,
                        source: this.$route.name,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.campaign=response.data.data[0]
                    }
                    this.isLoading=false
                })
            }
        },
        mounted () {
            this.getCampaign();
        },
    }
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
<style lang="scss" scoped>

</style>